import {IManagableObject} from "../../IManagableObject";
import {GeozoneViewModel} from "../../Geozone/Model/GeozoneViewModel";

export class StopViewModel {
  Id: number;
  ZoneId: number;
  Zone: GeozoneViewModel = new GeozoneViewModel();
  Name: string;
  Time: number = 0;
  Order: number;

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.ZoneId = data["zoneId"];
      this.Time = data["time"];
      this.Order = data["order"];
    }
  }

  static fromJS(data: any): StopViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new StopViewModel();
    result.init(data);
    return result;
  }
}

export class RouteViewModel implements IManagableObject {
  Id: number = 0;
  Name: string;
  Comment: string = "";

  Stops: StopViewModel[] = [];
  init(data?: any) {
    if (data) {
      this.Name = data["name"];
      this.Id = data["id"];
      this.Comment = data["comment"];
      let stops = data["stops"];
      if (stops && stops.constructor === Array) {
        for (let item of stops)
          this.Stops.push(StopViewModel.fromJS(item))
      }
    }
  }

  static fromJS(data: any): RouteViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new RouteViewModel();
    result.init(data);
    return result;
  }

  IsChecked: boolean;
}

